import { useEffect } from 'react';

const SCRIPT_ID = 'sunbowl-capture-script';
const SCRIPT_SRC = 'https://bucky-app-355a3.web.app/capture-embed.js';
const CAPTURE_ACTIVATE_URL = 'https://us-central1-bucky-app-355a3.cloudfunctions.net/captureActivate';
const PROJECT_ID = 'OOJrO8jfZGtWu4WIsALF';

/**
 * Activates the Sunbowl Capture feedback widget in always-on mode.
 * Calls captureActivate to get a 60-minute token, then loads the embed
 * script with that token. Refreshing the page renews the token.
 */
export function useSunbowlCapture() {
  useEffect(() => {
    if (document.getElementById(SCRIPT_ID)) return;

    async function activate() {
      try {
        const shopDomain =
          new URLSearchParams(window.location.search).get('shop') ||
          'sixhatssupply.myshopify.com';

        const res = await fetch(CAPTURE_ACTIVATE_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer shop:${shopDomain}`,
          },
          body: JSON.stringify({ projectId: PROJECT_ID }),
        });

        if (!res.ok) {
          console.warn('[SunbowlCapture] activation failed:', res.status);
          return;
        }

        const data = await res.json();
        if (!data.token) {
          console.warn('[SunbowlCapture] no token returned');
          return;
        }

        const script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.defer = true;
        script.src = SCRIPT_SRC;
        script.dataset.project = PROJECT_ID;
        script.dataset.token = data.token;
        script.dataset.mode = 'always';
        script.dataset.position = 'bottom-right';
        document.head.appendChild(script);
      } catch (err) {
        console.warn('[SunbowlCapture] activation error:', err);
      }
    }

    activate();
  }, []);
}
